<!-- <div class="tooltip-qr">
  <div class="close" (click)="close.emit()">
    <i class="pi pi-times"></i>
  </div> -->
  
  <div class="item">
    <div class="qr" [style.--icon-url]="'url(shell/profile/qr.svg)'"></div>
      <div class="text">
        <span>Código de Promotor</span>
        <p>PRJVC74010554</p>
      </div>
    <lib-ribera-default-btn 
      variant="outline" 
      size="small" 
      borderRadius="10px" 
      (press)="onCopyCode()"
    >
      Copiar
    </lib-ribera-default-btn>
  </div>
<!-- </div> -->